// NOVAPAY-116-RC3-R1 — in-memory legal navigation context (no PII in URLs).
export type LegalNavSource =
  | "start"
  | "legal_hub"
  | "menu"
  | "checkout"
  | "payment"
  | "order_status"
  | "payment_retry"
  | "public";

export type LegalNavContext = {
  source: LegalNavSource;
  returnScrollTop: number;
  /** When true, document Back skips the hub and returns to origin route. */
  skipHubOnDocumentBack: boolean;
  checkoutStep?: string | null;
};

let active: LegalNavContext | null = null;

export function setLegalNavContext(ctx: LegalNavContext): void {
  active = ctx;
}

export function peekLegalNavContext(): LegalNavContext | null {
  return active;
}

export function clearLegalNavContext(): void {
  active = null;
}

export function consumeLegalNavContext(): LegalNavContext | null {
  const ctx = active;
  active = null;
  return ctx;
}

export function legalSourceSkipsHub(source: LegalNavSource): boolean {
  return (
    source === "checkout" ||
    source === "payment" ||
    source === "payment_retry" ||
    source === "order_status" ||
    source === "start"
  );
}
